import { useContext, useEffect, useState } from "react";
import {
  Attribute,
  AttributeGroup,
  AttributeProperty,
  ComponentProps,
  ConfigContext,
  ConfigsProvider,
  PromiseLoader,
} from "react-builder";
import { useProductApi } from "../../custom-hooks/useProductApi";
import { Movie } from "../../types/multimedia-types";
import { MultimediaUserDataContext } from "./MultimediaUserDataProvider";

@AttributeGroup({
  title: "SingleMovieProvider",
  blockName: "SingleMovieProvider",
  module: "multimedia",
  icon: "query",
})
export class SingleMovieProviderAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  movieID = "";
}

export function SingleMovieProvider(props: ComponentProps<SingleMovieProviderAttributes>) {
  const content = useContext(ConfigContext);
  const singleMovieAPI = useProductApi<Movie>();
  const movieID = props.attributes.movieID ? content.getContent(props.attributes.movieID) : "";
  const [moviePromise, setMoviesPromise] = useState<Promise<Movie>>();
  const { addMovieToFavorites, removeMovieFromFavorites, favoritesMovies } =
    useContext(MultimediaUserDataContext);
  useEffect(() => {
    const list = async () => {
      if (!singleMovieAPI) return;
      try {
        const moviePromise = singleMovieAPI.single(`multimedia/Movie/${movieID}`, {
          populate: "preview subtitles.file",
        });
        setMoviesPromise(moviePromise);
      } catch (error) {
        console.error("Error fetching Movies:", error);
      }
    };

    list();
  }, [singleMovieAPI, movieID]);

  const isFavorite = (movieId: string) => {
    if (!favoritesMovies || !favoritesMovies.length) return false;
    return !!favoritesMovies?.find((m) => m._id === movieId);
  };
  return (
    <PromiseLoader<Movie> promise={moviePromise} loader={<></>}>
      {(movie) => (
        <ConfigsProvider
          configJson={{
            movie: {
              ...movie,
              isFavorite: isFavorite(movie?._id || ""),
              addMovieToFavorites: () => addMovieToFavorites(movie as Movie),
              removeMovieFromFavorites: () => removeMovieFromFavorites(movie?._id || ""),
            },
          }}
        >
          <>{props.children}</>
        </ConfigsProvider>
      )}
    </PromiseLoader>
  );
}

SingleMovieProvider.prototype.Props = SingleMovieProviderAttributes;

export default SingleMovieProvider;
